import React from "react";
import { Controller } from "react-hook-form";
import {
    FormControl,
    FormLabel,
    RadioGroup,
    FormControlLabel,
    Radio,
    FormHelperText,
} from "@mui/material";
import { buildValidationRules, getReadOnlyStyles, HELPER_TEXT_STYLES } from "../fieldHelpers";

const RadioFieldRenderer = ({ field, control }) => {
    const {
        name,
        label,
        options = [],
        required = false,
        fullWidth = true,
        disabled = false,
        readOnly = false,
        row = true,
        onChange: externalOnChange,
        error: externalError,
        helperText: externalHelperText,
    } = field;

    const rules = buildValidationRules(field);

    const toRadioString = (v) => {
        if (v === true) return "true";
        if (v === false) return "false";
        if (v === null || v === undefined) return "";
        return String(v);
    };

    const fromRadioString = (radioStr) => {
        const opt = options.find((o) => toRadioString(o.value) === radioStr);
        return opt ? opt.value : radioStr;
    };

    return (
        <Controller
            key={name}
            name={name}
            control={control}
            rules={rules}
            render={({ field: { onChange, value }, fieldState: { error } }) => {
                const hasExternalError = Boolean(externalError);
                const hasRHFError = Boolean(error);

                const showError = hasExternalError || hasRHFError;
                const helperText = (externalHelperText || error?.message || "").toString();

                const radioValue = toRadioString(value);

                return (
                    <FormControl fullWidth={fullWidth} required={required} disabled={disabled} error={showError}>
                        {!!label && <FormLabel sx={{ mb: 0.5 }}>{label}</FormLabel>}

                        <RadioGroup
                            row={row}
                            value={radioValue}
                            onChange={(e) => {
                                if (disabled || readOnly) return;

                                const newValue = fromRadioString(e.target.value);

                                onChange(newValue);

                                if (typeof externalOnChange === "function") {
                                    externalOnChange(newValue);
                                }
                            }}
                            sx={getReadOnlyStyles(readOnly)}
                        >
                            {options.map((opt) => (
                                <FormControlLabel
                                    key={toRadioString(opt.value)}
                                    value={toRadioString(opt.value)}
                                    control={<Radio />}
                                    label={opt.label}
                                    disabled={disabled || readOnly}
                                />
                            ))}
                        </RadioGroup>

                        {showError && (
                            <FormHelperText sx={HELPER_TEXT_STYLES}>
                                {helperText}
                            </FormHelperText>
                        )}
                    </FormControl>
                );
            }}
        />
    );
};

export default RadioFieldRenderer;
